import { makeStyles } from '@material-ui/core'
import { Theme } from '@styles/theme/theme'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '100%',
    width: '100%',
    flexGrow: 1,
    paddingTop: 12,
  },
  leftSideContainer: {
    height: '100%',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '16px',
    padding: '16px 24px',
  },
  leftHeader: {
    height: '40px',
    display: 'flex',
    alignItems: 'center'
  },
  leftHeaderButton: {
    padding: 0,
    width: 24,
    height: 24,
    borderRadius: '4px',
    '&.Mui-disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'auto'
    }
  },
  leftTitle: {
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '16px',
    marginBottom: '16px'
  },
  leftParagraph: {
    opacity: 0.8,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    marginBottom: '16px'
  },
  leftContent: {
    width: '100%',
    height: '100%',
    marginTop: 18,
    overflow: 'hidden',
    position: 'relative',
    '& span': {
      opacity: 0.8,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
    },
    [theme.breakpoints.up('md')]: {
      '& > div': {
        position: 'absolute',
        top: 0
      }
    },
    [theme.breakpoints.down('md')]: {
      minHeight: '50vh'
    }
  },
  actionButtonsContainer: {
    gap: '16px',
    marginBottom: '30px',
    marginTop: '30px',
    [theme.breakpoints.down('sm')]: {
      gap: '4px',
    }
  },
  actionButton: {
    padding: 0,
    width: 24,
    height: 24,
    minWidth: 0,
    borderRadius: '4px',
    border: 'none',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      height: 40,
      border: '1px solid rgba(97, 64, 255, 0.1)',
      borderRadius: '8px',
      color: theme.palette.primary.main,
      padding: 8,
      '& span': {
        fontWeight: 700,
        fontSize: '14px',
        lineHeight: '24px',
        gap: 8
      }
    }
  },
  rightSideContainer: {
    height: '100%',
    borderRadius: 16,
    backgroundColor: theme.palette.isabelline,
    padding: '40px'
  },
  title: {
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '23px',
    '&:not(:first-child)': {
      margin: '16px 0'
    }
  },
  paragraph: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '28px',
    marginBottom: '8px',
    color: 'rgba(17,17,17,0.3)',
  },
  sendsparkButton: {
    marginBottom: 8,
    boxShadow: '0px 4px 10px rgba(97, 64, 255, 0.2)',
  },
  socialButtonsContainer: {
    gap: 12
  },
  socialButton: {
    width: 36,
    height: 36,
    padding: 0,
    background: 'rgba(0, 0, 0, 0.1)',
  },
  option: {
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '36px',
    opacity: 0.5,
    '&:not(.Mui-disabled):hover, &.active': {
      opacity: 1,
      color: theme.palette.primary.main
    },
    '&:not(.Mui-disabled):hover path': {
      stroke: theme.palette.majorelleBlue
    },
    '&.Mui-disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'auto'
    }
  },
  optionContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 11,
    [theme.breakpoints.up('sm')]: {
      width: 100,
    }
  },
  typedSpan: {
    whiteSpace: 'pre-line',
  },
  panels: {
    [theme.breakpoints.up('sm')]: {
      padding: '0px 12px!important'
    }
  },
  link: {
    color: 'rgba(97, 64, 255, 1)',
    textDecoration: 'none',
    fontWeight: 700,
  }
}))

export default useStyles
